
import React from 'react';
import { Sector, CaseStudy, Feature } from './types';

export const COLORS = {
  novusGreen: '#00D47E',
  carbonBlack: '#1E1E1E',
  slateGrey: '#8D959D',
  vaporWhite: '#F2F4F4',
};

export const CASE_STUDIES: CaseStudy[] = [
  {
    id: '1',
    clientName: 'Vortex Energy',
    logo: '',
    sector: Sector.Industrial,
    quote: "We have used services from Novus Energy for most of our stations, this is our strategic step to continue to increase the number of solar panel usage for our stations, we are very satisfied with the services from Novus.",
    author: {
      name: 'Jennifer Kolobaly',
      role: 'CTO Vortex Global'
    },
    metrics: {
      energySaved: 450000,
      co2Reduced: 120
    },
    heroImage: 'https://picsum.photos/1200/800?random=101'
  },
  {
    id: '2',
    clientName: 'TerraNova',
    logo: '',
    sector: Sector.Residential,
    quote: "Housing in the future really needs clean and reliable energy sources, Novus really helps us to continue developing our renewable energy.",
    author: {
      name: 'Manahan Mana',
      role: 'Head of Infrastructure'
    },
    metrics: {
      energySaved: 280000,
      co2Reduced: 85
    },
    heroImage: 'https://picsum.photos/1200/800?random=102'
  }
];

export const CLIENTS = [
  { 
    name: 'Vortex Tech', 
    logo: (
      <svg className="w-full h-full" viewBox="0 0 100 40" fill="currentColor">
        <path d="M5 5L15 20L5 35M20 5L30 20L20 35" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        <text x="40" y="26" className="text-[12px] font-black tracking-tight" fill="currentColor">VORTEX</text>
      </svg>
    ) 
  },
  { 
    name: 'Solaris', 
    logo: (
      <svg className="w-full h-full" viewBox="0 0 100 40" fill="currentColor">
        <circle cx="15" cy="20" r="10" fill="none" stroke="currentColor" strokeWidth="4" />
        <circle cx="15" cy="20" r="4" fill="currentColor" />
        <text x="32" y="26" className="text-[12px] font-black tracking-tighter" fill="currentColor">SOLARIS</text>
      </svg>
    ) 
  },
  { 
    name: 'EcoFlow', 
    logo: (
      <svg className="w-full h-full" viewBox="0 0 100 40" fill="currentColor">
        <path d="M5 10H20V30H5V10Z" fill="none" stroke="currentColor" strokeWidth="4" />
        <path d="M10 10V5M15 10V5" stroke="currentColor" strokeWidth="2" />
        <text x="28" y="26" className="text-[12px] font-black tracking-tight" fill="currentColor">ECOFLOW</text>
      </svg>
    ) 
  },
  { 
    name: 'TerraNova', 
    logo: (
      <svg className="w-full h-full" viewBox="0 0 100 40" fill="currentColor">
        <path d="M5 25C15 10 25 10 35 25" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
        <circle cx="20" cy="25" r="3" fill="currentColor" />
        <text x="5" y="38" className="text-[10px] font-black tracking-[0.2em]" fill="currentColor">TERRANOVA</text>
      </svg>
    ) 
  },
  { 
    name: 'Zenith', 
    logo: (
      <svg className="w-full h-full" viewBox="0 0 100 40" fill="currentColor">
        <path d="M10 5L30 5L10 35L30 35" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        <text x="40" y="26" className="text-[12px] font-black tracking-widest" fill="currentColor">ZENITH</text>
      </svg>
    ) 
  }
];

export const FEATURES: Feature[] = [
  {
    id: '1',
    title: 'Layered security',
    description: 'With layered security, we ensure the safety of every unit we provide.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a7 7 0 10-14 0v2" />
      </svg>
    )
  },
  {
    id: '2',
    title: 'Quality control of each part',
    description: 'Every unit you send is checked carefully for every detail.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    )
  },
  {
    id: '3',
    title: 'Reliable customer service',
    description: 'Our customer service is available 24 hours a week, with qualified people.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    )
  },
  {
    id: '4',
    title: 'Maintenance manual book',
    description: 'We provide a guidebook that can be used to ensure maximum care.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
    )
  },
  {
    id: '5',
    title: 'Delivered safely',
    description: 'Every unit we send arrives safely and quickly, without any obstacles.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    )
  },
  {
    id: '6',
    title: 'Based on artificial intelligence',
    description: 'You can control and view each unit from your phone, its very easy to use.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <rect x="6" y="2" width="12" height="20" rx="3" />
        <path d="M11 19h2" strokeLinecap="round" />
        <path d="M9 5h6" strokeLinecap="round" />
      </svg>
    )
  }
];
